"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogoRoute = void 0;
const next_i18next_1 = require("next-i18next");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const fdr_lib_page_available_pages_1 = require("@hotelplan/fdr.lib.page.available-pages");
function useLogoRoute() {
    const [, { language }] = (0, next_i18next_1.useTranslation)();
    const homePageRoute = (0, libs_router_config_1.getRouteByPageTypeLocale)(fdr_lib_page_available_pages_1.EPageType.Home, language);
    return {
        link: {
            url: homePageRoute.builder({}),
            type: supergraph_api_1.FdrLinkType.Internal,
            openMethod: supergraph_api_1.FdrLinkOpenMethod.ThisTab,
        },
    };
}
exports.useLogoRoute = useLogoRoute;
//# sourceMappingURL=use-logo-route.js.map